import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/vi-en-logo.png'


_pushScopeId("data-v-dfb7b15e")
const _hoisted_1 = {
  key: 0,
  class: "login-in"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "login-right_logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sign-in" }, "SIGN IN", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { style: {"float":"left"} }
const _hoisted_6 = { class: "verify-in" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "agreement" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "I have read and agree", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "and", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Login in")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-right" }, null, -1)
const _hoisted_14 = { class: "no-login" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("No login for 7 days")
const _hoisted_16 = ["loading"]
const _hoisted_17 = ["loading"]
const _hoisted_18 = {
  key: 1,
  class: "login-in"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "login-right_logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "span-login" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "back_login" })
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "span-login_psw" }, "Back To Studio", -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "verify-in" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 0,
  class: "send-code-tips"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "An Email will be sent to you mailbox", -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Submit")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CircleCheckFilled = _resolveComponent("CircleCheckFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Verify = _resolveComponent("Verify")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loginDisabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createVNode(_component_el_form, {
            class: "form-in",
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "ruleForm"
          }, {
            default: _withCtx(() => [
              (_ctx.codeLogin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_el_form_item, {
                      class: "form-li",
                      prop: "phone"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.areaCode,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.formData.areaCode = $event)),
                          style: {"width":"26%"}
                        }, {
                          prefix: _withCtx(() => [
                            _createElementVNode("i", {
                              class: _normalizeClass(_ctx.isPhoneBlue)
                            }, null, 2)
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryCode, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.code,
                                label: `+${item.code == 2 ? '1' : item.code}`,
                                value: item.code
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_5, "+" + _toDisplayString(item.code) + " " + _toDisplayString(item.en), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_el_input, {
                          class: "phone-input",
                          style: {"width":"74%"},
                          onKeydown: _withKeys(_ctx.submitForm, ["enter"]),
                          modelValue: _ctx.formData.phone,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.phone = $event)),
                          modelModifiers: { trim: true },
                          onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onInputFocus($event, 'phone'))),
                          onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onInputFocus($event, 'phone'))),
                          placeholder: "Type You Telnum"
                        }, null, 8, ["onKeydown", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      class: "form-li",
                      prop: "verify"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_input, {
                            onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onInputFocus($event, 'checkCode'))),
                            onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onInputFocus($event, 'checkCode'))),
                            onKeydown: _withKeys(_ctx.submitForm, ["enter"]),
                            modelValue: _ctx.formData.verify,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.verify = $event)),
                            modelModifiers: { trim: true },
                            placeholder: "Enter One Code",
                            disabled: !_ctx.isSendPhoneCode
                          }, _createSlots({
                            prefix: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass(_ctx.ischeckCodeBlue)
                              }, null, 2)
                            ]),
                            _: 2
                          }, [
                            (_ctx.isSendPhoneCode)
                              ? {
                                  name: "suffix",
                                  fn: _withCtx(() => [
                                    (!_ctx.countDown)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          style: {"color":"#434af9","cursor":"pointer","font-size":"12px"},
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSendPhoneCode(1)))
                                        }, " Send Code "))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.countDown) + " s", 1))
                                  ])
                                }
                              : undefined
                          ]), 1032, ["onKeydown", "modelValue", "disabled"])
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_el_form_item, {
                      class: "form-li",
                      prop: "username"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          onKeydown: _withKeys(_ctx.submitForm, ["enter"]),
                          modelValue: _ctx.formData.username,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.username = $event)),
                          modelModifiers: { trim: true },
                          onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onInputFocus($event, 'username'))),
                          onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onInputFocus($event, 'username'))),
                          placeholder: "Type You Email Or Telnum",
                          maxLength: "50"
                        }, {
                          prefix: _withCtx(() => [
                            _createElementVNode("i", {
                              class: _normalizeClass(_ctx.isUserNameBlue)
                            }, null, 2)
                          ]),
                          _: 1
                        }, 8, ["onKeydown", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      class: "form-li form-li-error",
                      prop: "password"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          "show-password": "",
                          onKeydown: _withKeys(_ctx.submitForm, ["enter"]),
                          modelValue: _ctx.formData.password,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.password = $event)),
                          modelModifiers: { trim: true },
                          onFocus: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onInputFocus($event, 'password'))),
                          onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onInputFocus($event, 'password'))),
                          placeholder: "Type You Password",
                          type: "password",
                          minLength: "8",
                          maxLength: "18"
                        }, {
                          prefix: _withCtx(() => [
                            _createElementVNode("i", {
                              class: _normalizeClass(_ctx.isPasswordBlue)
                            }, null, 2)
                          ]),
                          _: 1
                        }, 8, ["onKeydown", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.agreeChecked,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.agreeChecked = $event)),
              size: "large"
            }, null, 8, ["modelValue"]),
            _hoisted_10,
            _createElementVNode("div", {
              target: "_blank",
              class: "agreementLink",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleGoAgreement('agreementEn')))
            }, " Service agreement "),
            _hoisted_11,
            _createElementVNode("div", {
              target: "_blank",
              class: "agreementLink",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleGoAgreement('privacyEn')))
            }, " Privacy policy ")
          ]),
          _createVNode(_component_el_button, {
            loading: _ctx.loging,
            class: "login-button",
            onClick: _ctx.submitForm,
            type: "primary",
            size: "medium"
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["loading", "onClick"]),
          false
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "toggle-login-type",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.codeLogin = !_ctx.codeLogin))
              }, [
                _createTextVNode(_toDisplayString(_ctx.codeLogin ? 'Account Password Login' : 'Telnum Dynamic Code Login') + " ", 1),
                _hoisted_13
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.noLogin,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.noLogin = $event)),
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", {
              class: "forget-button",
              loading: _ctx.loging,
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setNewPsw(false)))
            }, "Forget You Password?", 8, _hoisted_16),
            _createElementVNode("span", {
              class: "create-button",
              loading: _ctx.loging,
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setNewPsw(true)))
            }, "Create Account", 8, _hoisted_17)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.forgetPswDisabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", {
            class: "div-login_tab",
            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, _hoisted_22),
          _createVNode(_component_el_form, {
            class: "form-in",
            model: _ctx.formData,
            rules: _ctx.forgetRules,
            ref: "reRuleForm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                class: "form-li",
                prop: "email"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    onKeydown: _withKeys(_ctx.submitForm, ["enter"]),
                    onFocus: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onInputFocus($event, 'email'))),
                    onBlur: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onInputFocus($event, 'email'))),
                    modelValue: _ctx.formData.email,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.formData.email = $event)),
                    modelModifiers: { trim: true },
                    placeholder: "Type You Email"
                  }, {
                    prefix: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.isEmailBlue)
                      }, null, 2)
                    ]),
                    _: 1
                  }, 8, ["onKeydown", "modelValue"]),
                  (_ctx.isRegistered)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "login-link",
                        onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                      }, "login"))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "form-li",
                prop: "emailCode"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_el_input, {
                      onFocus: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onInputFocus($event, 'emailCode'))),
                      onBlur: _cache[28] || (_cache[28] = ($event: any) => (_ctx.onInputFocus($event, 'emailCode'))),
                      onKeydown: _withKeys(_ctx.submitForm, ["enter"]),
                      modelValue: _ctx.formData.emailCode,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.formData.emailCode = $event)),
                      modelModifiers: { trim: true },
                      placeholder: "Enter one code"
                    }, _createSlots({
                      prefix: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass(_ctx.ischeckEmailCodeBlue)
                        }, null, 2)
                      ]),
                      _: 2
                    }, [
                      (_ctx.isSendEmailCode)
                        ? {
                            name: "suffix",
                            fn: _withCtx(() => [
                              (!_ctx.countDownEmail)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    style: {"color":"#434af9","cursor":"pointer","font-size":"12px"},
                                    onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.handleSendPhoneCode(2)))
                                  }, " Send message "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_24, "Message was sent"))
                            ])
                          }
                        : undefined
                    ]), 1032, ["onKeydown", "modelValue"])
                  ]),
                  (_ctx.countDownEmail && _ctx.countDownEmail >= 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_CircleCheckFilled)
                          ]),
                          _: 1
                        }),
                        _hoisted_26
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "form-li form-li-error",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    "show-password": "",
                    onKeydown: _withKeys(_ctx.submitForm, ["enter"]),
                    modelValue: _ctx.formData.password,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.formData.password = $event)),
                    modelModifiers: { trim: true },
                    onFocus: _cache[31] || (_cache[31] = ($event: any) => (_ctx.onInputFocus($event, 'password'))),
                    onBlur: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onInputFocus($event, 'password'))),
                    placeholder: "Enter one password",
                    type: "password"
                  }, {
                    prefix: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.isPasswordBlue)
                      }, null, 2)
                    ]),
                    _: 1
                  }, 8, ["onKeydown", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "form-li form-li-error",
                prop: "passwordAgain"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    "show-password": "",
                    onKeydown: _withKeys(_ctx.submitForm, ["enter"]),
                    modelValue: _ctx.formData.passwordAgain,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.formData.passwordAgain = $event)),
                    modelModifiers: { trim: true },
                    onFocus: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onInputFocus($event, 'passwordAg'))),
                    onBlur: _cache[35] || (_cache[35] = ($event: any) => (_ctx.onInputFocus($event, 'passwordAg'))),
                    placeholder: "Enter one password again",
                    type: "password"
                  }, {
                    prefix: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.isPasswordAGBlue)
                      }, null, 2)
                    ]),
                    _: 1
                  }, 8, ["onKeydown", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createVNode(_component_el_button, {
            loading: _ctx.loging,
            class: "login-button",
            onClick: _ctx.submitForm,
            type: "primary",
            size: "medium"
          }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Verify, {
      lang: "en",
      imgSize: { width: '400px', height: '200px' },
      ref: "verify",
      onSuccess: _ctx.onSuccess
    }, null, 8, ["onSuccess"])
  ]))
}